import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core';
import { SocialLoginModule, AuthServiceConfig } from 'angularx-social-login';
import { GoogleLoginProvider, FacebookLoginProvider } from 'angularx-social-login';
import { CommonModule } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {   MatSidenavModule, 
   MatButtonModule, 
   MatDialogModule} from '@angular/material'
   import {MatInputModule} from '@angular/material/input';
   import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatExpansionModule} from '@angular/material/expansion';




import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { LoginComponent } from './components/login/login.component';
import { SignupComponent } from './components/signup/signup.component';
import { ProfileComponent } from './components/profile/profile.component';
import { RequestResetComponent } from './components/password/request-reset/request-reset.component';
import { ResponseResetComponent } from './components/password/response-reset/response-reset.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DataService } from './services/data.service';
import { TokenService } from './services/token.service';
import { AuthService } from "./services/auth.service";
import { AfterLoginService } from './services/after-login.service';
import { BeforeLoginService } from './services/before-login.service';
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { SidebarsComponent } from './sidebars/sidebars.component';
import { AboutComponent } from './about/about.component';
import { CoursesComponent } from './courses/courses.component';
import { CourseEnrollmentComponent } from './course-enrollment/course-enrollment.component';
import { CourseModulesComponent } from './course-modules/course-modules.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { LoadsessionDirective } from './loadsession.directive';
import { TermConditionComponent } from './term-condition/term-condition.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { FaqComponent } from './faq/faq.component';
import { HelpSupportComponent } from './help-support/help-support.component';
import { CourseSessionComponent } from './course-session/course-session.component';
import { StartSessionComponent } from './course-session/start-session/start-session.component';
import { InvoiceComponent } from './payment-history/invoice/invoice.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { AutoGeneratedComponent } from './auto-generated/auto-generated.component';
import { QuizComponent } from './quiz/quiz.component';

import { RatingModule } from 'ng-starrating';
import { ChartsModule } from 'ng2-charts';
import { QuizResultComponent } from './quiz-result/quiz-result.component';
import { ContactmodalComponent } from './contactmodal/contactmodal.component';
import { ComplaintComponent } from './complaint/complaint.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { MustMatchDirective } from './_helpers/must-match.directive';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { PaymentLinkComponent } from './payment-link/payment-link.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { DatePickerModule,CalendarModule, TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { NgSlimScrollModule, SLIMSCROLL_DEFAULTS } from 'ngx-slimscroll';
import { FeedbackComponent } from './feedback/feedback.component';
import { TestCalendarComponent } from './test-calendar/test-calendar.component';

import { ContactmodalService } from './services/contactmodal.service'
import { ContactmodalDirective } from './services/contactModal.directive';
import { RaiseAQueryComponent } from './raise-a-query/raise-a-query.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { FeedbackpopupComponent } from './feedbackpopup/feedbackpopup.component';
import {TimeAgoPipe} from 'time-ago-pipe';
import { FooterComponent } from './footer/footer.component';

import { LivechatWidgetModule } from '@livechat/angular-widget';
import { Footer2Component } from './footer2/footer2.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component'



let config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider("Google-OAuth-Client-Id")
  },
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider('2830542083627472')
  }
]);

export function provideConfig() {
  return config;
}


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    LoginComponent,
    SignupComponent,
    ProfileComponent,
    RequestResetComponent,
    ResponseResetComponent,
    HeaderComponent,
    HomeComponent,
    SidebarsComponent,
    AboutComponent,
    CoursesComponent,
    CourseEnrollmentComponent,
    CourseModulesComponent,
    PaymentHistoryComponent,
    LoadsessionDirective,
    TermConditionComponent,
    PrivacyPolicyComponent,
    FaqComponent,
    HelpSupportComponent,
    CourseSessionComponent,
    StartSessionComponent,
    InvoiceComponent,
    NotfoundComponent,
    AutoGeneratedComponent,
    QuizComponent,
    QuizResultComponent,
    ContactmodalComponent,
    ComplaintComponent,
    ChangePasswordComponent,
    MustMatchDirective,
    VerifyEmailComponent,
    PaymentLinkComponent,
    ThankyouComponent,
    FeedbackComponent,
    TestCalendarComponent,
    ContactmodalDirective,
    RaiseAQueryComponent,
    ContactUsComponent,
    FeedbackpopupComponent,
    TimeAgoPipe,
    FooterComponent,
    Footer2Component,
    ConfirmationDialogComponent,
 

  ],

entryComponents :[InvoiceComponent,
  ComplaintComponent,
  SidebarsComponent,
  ContactmodalComponent,
  ChangePasswordComponent,
  ProfileComponent,
  FeedbackComponent,
  TestCalendarComponent,
  FeedbackpopupComponent,
  ConfirmationDialogComponent
  
],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SnotifyModule,
    SocialLoginModule,
    CommonModule,
    ToastrModule.forRoot(),
    RatingModule ,
    ChartsModule,
    MatDatepickerModule,
    MatRippleModule,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonModule,
    MatDialogModule,
    MatNativeDateModule,
    DatePickerModule,
    CalendarModule,
    TimePickerModule,
    MatExpansionModule,
    NgSlimScrollModule,
   MatInputModule,
   LivechatWidgetModule
    
   
  ],

  providers: [ContactmodalService, DataService, TokenService, AuthService, AfterLoginService, BeforeLoginService, 
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults },
    {
      provide: SLIMSCROLL_DEFAULTS,
      useValue: {
        alwaysVisible : false
      }
    },
    SnotifyService,
    {provide: AuthServiceConfig, useFactory: provideConfig },
    ],
  bootstrap: [AppComponent]
})



export class AppModule { }


